import React from 'react';

export default React.createContext({});



// WEBPACK FOOTER //
// ./src/common/context/GGEditorContext/index.js